// WizardStepHero — Livfull per-step hero (big friendly heading + subtitle), rendered at the top
// of each activity-wizard step above the sections. Pure presentation; text is passed in (i18n
// resolved by the caller). Mirrors the prototype `.stephero` (h2 ~22px bold + muted subtitle).
// Activity-wizard only in this track (booking-wizard hero is a separate later decision).

interface WizardStepHeroProps {
  title: string;
  subtitle?: string;
}

export default function WizardStepHero({ title, subtitle }: WizardStepHeroProps) {
  return (
    <div className="mb-1">
      <h2 className="text-[22px] font-bold leading-tight tracking-tight">{title}</h2>
      {subtitle && (
        <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{subtitle}</p>
      )}
    </div>
  );
}
